// src/components/header/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';


import './Header.css';

function Header() {

  const navigate = useNavigate();
  const buttonPath = "/curnicielloedition/";

  const handleNavigation = () => {
    navigate(buttonPath)
  }

  return (
    <header className='header'>
      <div className='hero-banner'>
        <h1>CURNICIELLO EDITION</h1>
        <button className='header-button' onClick={handleNavigation}>
          Check it Out Now!
        </button>
      </div>
    </header>
  );
}

export default Header;
